import React from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import { useTranslation } from "react-i18next";

import Styles from "./PlanYourTrip.module.css";
import BasicDatePicker from "./BasicDatePicker";
import Governorates from "./Data/Governorates.en";
import MultiSelectDropdown from "./MultiSelectDropdown";
import InterestedPlaces from "./InterestedPlacesType";
import people from "./People";
import Schema from "./Schema";

import { Checkbox, FormControlLabel } from "@mui/material";

import Budget from "./Budget";

const lngs = [
	{
		label: "عربي",
		value: "arabic",
	},
	{
		label: "English",
		value: "english",
	},
	{
		label: "كوردي",
		value: "kurdish",
	},
];

function PlanYourTrip() {
	const { t, i18n } = useTranslation();

	const localizedGovernorates = Object.values(
		t("PlanyourTrip.governorates", {
			returnObjects: true,
		}) || {}
	);

	const localizedInterestedPlaces = Object.values(
		t("PlanyourTrip.interstedPlaces", {
			returnObjects: true,
		}) || {}
	);

	const localizedPeopleOption = Object.values(
		t("PlanyourTrip.noOfPeople", {
			returnObjects: true,
		}) || {}
	);

	const isRtl =
		i18n.language === "ar" || i18n.language === "ku";

	return (
		<>
			<h1
				className={Styles.h1}
				id='planyourtip'
			>
				{t("PlanyourTrip.title1")}
			</h1>
			<div>
				<Formik
					initialValues={{
						governorates: [],
						startDate: null,
						endDate: null,
						budget: null,
						interestedPlaces: [],
						languages: [],
						noOfPeople: [],
						touched: false,
					}}
					validationSchema={Schema}
					onSubmit={(values, actions) => {
						console.log(values);
						setTimeout(() => {
							alert(JSON.stringify(values, null, 2));
							actions.setSubmitting(false);
						});
						actions.resetForm();
					}}
				>
					{({
						isSubmitting,
						values,
						setFieldValue,
						handleChange,
					}) => (
						<Form
							className={
								isRtl
									? Styles.TripWrapperRTL
									: Styles.TripWrapper
							}
						>
							<div>
								<h2>{t("PlanyourTrip.wantToExplore")}</h2>
								<MultiSelectDropdown
									values={values}
									setFieldValue={setFieldValue}
									options={localizedGovernorates}
									fieldName='governorates'
									label={t("PlanyourTrip.selectGoverTitle")}
								/>
							</div>
							<div className={Styles.date}>
								<div className={Styles.datePick}>
									<h2>{t("PlanyourTrip.startDate")}</h2>
									<BasicDatePicker
										name='startDate'
										label={t("PlanyourTrip.startDate")}
									/>
								</div>

								<div className={Styles.datePick}>
									<h2>{t("PlanyourTrip.endDate")}</h2>
									<BasicDatePicker
										name='endDate'
										label={t("PlanyourTrip.endDate")}
									/>
								</div>
							</div>

							<div>
								<h2>
									{t("PlanyourTrip.interestedPlacesTitle")}
								</h2>
								<MultiSelectDropdown
									values={values}
									setFieldValue={setFieldValue}
									options={localizedInterestedPlaces}
									fieldName='interestedPlaces'
									label={t(
										"PlanyourTrip.interestedPlacesLabel"
									)}
								/>
							</div>

							<div>
								<h2> {t("PlanyourTrip.totalBudget")}</h2>
								<div>
									<Budget
										name='budget'
										label={t("PlanyourTrip.budgetLabel")}
									/>
								</div>
							</div>

							<div>
								<h2> {t("PlanyourTrip.lngTitle")}</h2>
								{lngs.map((opt) => (
									<Field
										type='checkbox'
										name='languages'
										value={opt.value}
										as={FormControlLabel}
										checked={values.languages.includes(
											opt.value
										)}
										control={<Checkbox />}
										label={opt.label}
									/>
								))}
								<br />
								<ErrorMessage
									name='languages'
									component='div'
									className={Styles.error}
								/>
							</div>

							<div>
								<h2>{t("PlanyourTrip.pplTitle")}</h2>
								{localizedPeopleOption.map((opt) => (
									<Field
										type='checkbox'
										name='noOfPeople'
										value={opt.value}
										as={FormControlLabel}
										checked={values.noOfPeople.includes(
											opt.value
										)}
										control={<Checkbox />}
										label={opt.label}
									/>
								))}
								<br />
								<ErrorMessage
									name='noOfPeople'
									component='div'
									className={Styles.error}
								/>
							</div>

							<button
								type='submit'
								disabled={isSubmitting}
								className={Styles.btn}
							>
								{t("PlanyourTrip.submit")}
							</button>
						</Form>
					)}
				</Formik>
			</div>
		</>
	);
}

export default PlanYourTrip;
